class PremiumBoxAutoAdd {
  constructor() {
    this.config = window.Theme?.premiumBox;
    if (!this.config || !this.config.enabled) return;
    this.init();
  }

  init() {
    const premiumBoxId = this.config.variantId;
    const customVariantIds = new Set(this.config.customVariantIds);
    if (!premiumBoxId || customVariantIds.size === 0) return;

    const originalFetch = window.fetch;
    window.fetch = async function(url, config) {
      try {
        let requestUrl = typeof url === 'string' ? url : (url?.url || '');

        if (requestUrl.includes('/cart/add')) {
          await new Promise(resolve => requestAnimationFrame(resolve));

          let variantIdAdded = null;
          let originalQuantity = 1;
          let isFormData = false;
          let originalProperties = {};

          if (config && config.body) {
            if (config.body instanceof FormData) {
              variantIdAdded = parseInt(config.body.get('id') || config.body.get('items[0][id]'));
              originalQuantity = parseInt(config.body.get('quantity') || 1);
              isFormData = true;

              for (let [key, value] of config.body.entries()) {
                if (key.startsWith('properties[')) {
                  let propName = key.replace('properties[', '').replace(']', '');
                  originalProperties[propName] = value;
                }
              }
            } else if (typeof config.body === 'string') {
              const parsed = JSON.parse(config.body);
              variantIdAdded = parseInt(parsed.id || (parsed.items && parsed.items[0]?.id));
              originalQuantity = parseInt(parsed.quantity || (parsed.items && parsed.items[0]?.quantity) || 1);
              if (parsed.properties) originalProperties = parsed.properties;
              if (parsed.items && parsed.items[0]?.properties) originalProperties = parsed.items[0].properties;
            }
          }

          if (variantIdAdded && customVariantIds.has(variantIdAdded)) {
            await new Promise(resolve => requestAnimationFrame(resolve));

            const cartRes = await originalFetch((window.Shopify?.routes?.root || '/') + 'cart.js');
            const cartData = await cartRes.json();
            const hasPremiumBox = cartData.items.some(item => item.variant_id === premiumBoxId);

            if (!hasPremiumBox) {
              const newBody = {
                items: [
                  {
                    id: variantIdAdded,
                    quantity: originalQuantity,
                    properties: Object.keys(originalProperties).length > 0 ? originalProperties : undefined
                  },
                  {
                    id: premiumBoxId,
                    quantity: 1,
                    properties: { '_Obligatorio': 'Incluido' }
                  }
                ]
              };

              if (isFormData) {
                const sections = config.body.get('sections');
                const sectionsUrl = config.body.get('sections_url');
                if (sections) newBody.sections = sections;
                if (sectionsUrl) newBody.sections_url = sectionsUrl;
              } else if (typeof config.body === 'string') {
                const parsed = JSON.parse(config.body);
                if (parsed.sections) newBody.sections = parsed.sections;
                if (parsed.sections_url) newBody.sections_url = parsed.sections_url;
              }

              config.body = JSON.stringify(newBody);

              if (!config.headers) config.headers = {};
              if (config.headers instanceof Headers) {
                config.headers.set('Content-Type', 'application/json');
              } else {
                config.headers['Content-Type'] = 'application/json';
              }
            }
          }
        }
      } catch (err) {
        console.error('Error inyectando la Caja Premium Seasons:', err);
      }

      return originalFetch(url, config);
    };
  }
}

new PremiumBoxAutoAdd();
export default PremiumBoxAutoAdd;
